import { Roles } from "@/models/user/roles";
import { PartialNetSuiteCustomer, PriceLevel } from "@/models/netsuite/netsuite";
import { SSOImpersonation } from "@/services/auth_service";
import { GlobalState } from "./types";

export const getLoading = (state: GlobalState): boolean => {
  return state.isLoading;
};

export const getLoggedIn = (state: GlobalState): boolean => {
  return state.isLoggedIn;
};

export const getRole = (state: GlobalState): Roles | null => {
  return state.userRole;
};

export const getMobile = (state: GlobalState): boolean => {
  return state.isMobile;
};

export const getTablet = (state: GlobalState): boolean => {
  return state.isTablet;
};

export const getMultiplier = (state: GlobalState): PriceLevel | null => {
  return state.multiplier;
};

export const getPriceLevels = (state: GlobalState): PriceLevel[] => {
  return state.priceLevels;
};

export const getCustomers = (state: GlobalState): PartialNetSuiteCustomer[] => {
  return state.customers;
};

export const getAuthToken = (state: GlobalState): string | null => {
  return state.authToken;
};

export const getImpersonation = (state: GlobalState): SSOImpersonation | null => {
  return state.impersonation;
};
